import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing } = redesignTheme;

export const useMeaningContentStyles = makeStyles(() => ({
  footnote: {
    margin: `${spacing.xs}px 0 0`,
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.textSecondary,
    fontStyle: 'italic',
  },
}));
